<template>
  <div class="page__data_center b-page" style="padding-top: 10px; min-height: 100vh">
    <div id="select-block" style="background-color:white; padding:10px 10px; overflow: hidden;">
      <div style="padding-left: 5px">
        <p class="text-primary" style="font-weight: bold; font-size: 20px">{{ 'Báo cáo theo tháng Custom' }}</p>
      </div>

      <el-row style="margin-top: 20px; padding-left: 5px">
        <el-col :sm="18">
          <div style="display: inline-block; margin-right: 10px">
            <shop-select v-model="selected_shops" :shopee_shop_list="shopee_shop.list" :multiple="true"
                         :collapse_tags="true" :disabled="loading.get_data"></shop-select>
          </div>
          <div style="display: inline-block">
            <el-date-picker
              id="date-picker-data-center"
              v-model="date"
              type="month"
              format="MM-yyyy"
              :picker-options="{firstDayOfWeek: 1, disabledDate(time) {return time.getTime() > Date.now()}}"
              :placeholder="$t('select.month')"
              size="small"
              :disabled="!shopee_shop.selected || loading.get_data">
            </el-date-picker>
          </div>
        </el-col>
        <el-col :sm="6" class="text-right" style="padding-right: 5px">
          <el-button size="small" type="primary" icon="el-icon-check" @click="m__update_data()"
                     :loading="loading.get_data" :disabled="!shopee_shop.selected">
            {{ $t('base.analyze_data') }}
          </el-button>
        </el-col>
      </el-row>
    </div>

    <div
      style="background-color:white; padding: 5px 10px 10px 10px; overflow: hidden; margin-top: 10px">
      <div style="margin-top: 30px">
        <div v-for="key in Object.keys(result)" style="margin-bottom: 60px">
          <div style="display: flex; align-items: center; justify-content: space-between">
            <strong style="font-size: 13px">
              {{ $t('base.shop') }}: {{ m__get_shop_name(key) }}
            </strong>

            <el-button v-if="result[key] && result[key].length" size="mini" icon="el-icon-download"
                       @click="m__export_data(key)">
              {{ $t('base.export_data') }}
            </el-button>
          </div>
          <div style="margin-top: 15px">
            <el-table :data="result[key]" :ref="`table_data_${key}`">
              <el-table-column :label="$t('base.data')" prop="label" width="120px" fixed="left"></el-table-column>
              <el-table-column label="Dữ liệu tổng" prop="total" min-width="100px">
                <template slot-scope="scope">
                  {{ scope.row.total | currency }}
                </template>
              </el-table-column>
              <el-table-column label="Thực hiện 1-7" prop="first_week" min-width="100px">
                <template slot-scope="scope">
                  {{ scope.row.first_week | currency }}
                </template>
              </el-table-column>
              <el-table-column label="Thực hiện 8-15" prop="second_week" min-width="100px">
                <template slot-scope="scope">
                  {{ scope.row.second_week | currency }}
                </template>
              </el-table-column>
              <el-table-column label="Thực hiện 16-22" prop="third_week" min-width="100px">
                <template slot-scope="scope">
                  {{ scope.row.third_week | currency }}
                </template>
              </el-table-column>
              <el-table-column label="Thực hiện 23-31" prop="forth_week" min-width="100px">
                <template slot-scope="scope">
                  {{ scope.row.forth_week | currency }}
                </template>
              </el-table-column>
              <el-table-column label="Thực hiện 1-15" prop="first_half" min-width="100px">
                <template slot-scope="scope">
                  {{ scope.row.first_half | currency }}
                </template>
              </el-table-column>
              <el-table-column label="Thực hiện 16-31" prop="last_half" min-width="100px">
                <template slot-scope="scope">
                  {{ scope.row.last_half | currency }}
                </template>
              </el-table-column>
              <el-table-column label="Thực hiện Flash sale" prop="sale_data" min-width="100px">
                <template slot-scope="scope">
                  {{ scope.row.sale_data | currency }}
                </template>
              </el-table-column>
              <el-table-column label="Thực hiện Mini sale 1" prop="first_mini_data" min-width="100px">
                <template slot-scope="scope">
                  {{ scope.row.first_mini_data | currency }}
                </template>
              </el-table-column>
              <el-table-column label="Thực hiện Mini sale 2" prop="second_mini_data" min-width="100px">
                <template slot-scope="scope">
                  {{ scope.row.second_mini_data | currency }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {get_shop_mixins} from "../../mixins/get_shop";
import {fix_ads_mixins} from "../../mixins/fix_ads";

export default {
  name: 'page__flash_sale_report',

  mixins: [get_shop_mixins, fix_ads_mixins],

  data() {
    return {
      loading: {
        get_data: false
      },
      selected_shops: [],
      date: this.dayjs().toDate(),
      seller: null,
      spike_days: [],
      temp_data: {
        gmv: 0,
        gmv_ads: 0,
        cost_ads: 0,
        order_ads: 0,
        cir: 0,
        roas: 0
      },
      result: {
        test: []
      }
    }
  },

  beforeMount() {
    this.m__get_spike_days()
    this.m__get_shopee_shop()
  },

  watch: {
    'shopee_shop.selected': function () {
      // this.m__initial_view()
    },
  },

  computed: {},

  methods: {
    async m__export_data(key) {
      const table_columns = this.$refs[`table_data_${key}`][0].columns

      const column_labels = table_columns.map(i => i.label)
      const data = []
      for (const row of this.result[key]) {
        const item = []
        for (const col of table_columns) {
          item.push(row[col.property])
        }
        data.push(item)
      }

      const filename = `custom_report_${this.m__get_shop_name(key)}_${this.dayjs(this.date).format('MMYYYY')}.xlsx`
      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/export_excel', {
        filename,
        data: [column_labels, ...data]
      }, {
        ...this.cf(),
        responseType: 'blob'
      })
      const url = window.URL.createObjectURL(new Blob([response.body]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
    },

    async m__initial_view() {
      const items = this.shopee_shop.list.filter(e => e._id === this.shopee_shop.selected)

      try {
        if (this.shopee_shop.selected.length > 6) {
          if (items.length > 0) {
            const shop = items[0]

            if (!this.check_role(shop, 'marketing', 'monthly_report')) {
              this.shopee_shop.selected = ''
              return
            }

            this.shop = shop
            this.seller = await this.init_seller(shop)

            if (!await this.check_shop(this.seller)) {
              this.shopee_shop.selected = ''
              return
            }

            this.ntf_s(`${this.$t('shop.connected_to')}: ${this.shop.username}`)
          }
        }
      } catch (e) {
        console.error(e)
        this.ntf_w(`${this.$t('shop.connect_shop_error')}: ${this.shop.username}`)
      } finally {
      }
    },

    async m__update_data() {
      if (!this.selected_shops.length) {
        this.ntf_w(this.$t('select.shop'))
        return
      }

      this.result = {}
      this.loading.get_data = true
      try {
        for (const shop_id of this.selected_shops) {
          console.log('start shop_id:', shop_id)

          const shop = await this.shopee_shop.list.find(i => i._id === shop_id)
          if (!shop) {
            console.log(`shop id: ${shop_id} not found`)
            continue
          }

          const seller = await this.init_seller(shop, false)

          const start_time = this.dayjs(this.date).startOf('month')
          const end_time = this.dayjs(this.date).endOf('month').isAfter(this.dayjs())
            ? this.dayjs()
            : this.dayjs(this.date).endOf('month')
          const key_metrics_end_time = this.dayjs(this.date).endOf('month').isAfter(this.dayjs())
            ? this.dayjs().subtract(1, 'day').endOf('day')
            : this.dayjs(this.date).endOf('month')

          const key_metrics_response = await seller.dashboard__key_metrics(start_time.unix(), key_metrics_end_time.add(1, 's').unix(), 'month')
          console.log('key_metrics_response', key_metrics_response)

          const ads_report_response = await seller.marketing_get_time_graph_by_month('new_cpc_homepage', start_time.unix(), end_time.endOf('day').unix(), {})
          console.log('ads_report_response', ads_report_response)

          if (key_metrics_response && key_metrics_response.result && ads_report_response && ads_report_response.data) {
            const total = this.clone(this.temp_data)
            for (const point of key_metrics_response.result.place_gmv.points) {
              total.gmv += +point.value
            }
            for (const point of ads_report_response.data.report_by_time) {
              total.gmv_ads += seller.m__calculate(point.metrics.broad_gmv / 100000)
              total.cost_ads += seller.m__calculate(point.metrics.cost / 100000)
              total.order_ads += +point.metrics.broad_order
            }
            total.cir = +total.gmv_ads ? parseFloat((total.cost_ads / total.gmv_ads * 100).toFixed(2)) : 0
            total.roas = +total.cost_ads ? parseFloat((total.gmv_ads / total.cost_ads).toFixed(2)) : 0

            const first_week = this.clone(this.temp_data)
            for (let i = 1; i <= 7; i++) {
              const start = this.dayjs(this.date).date(i).startOf('day').unix()
              const end = this.dayjs(this.date).date(i).endOf('day').unix()

              const gmv_found = key_metrics_response.result.place_gmv.points.find(i => i.timestamp >= start && i.timestamp <= end)
              first_week.gmv += gmv_found ? +gmv_found.value : 0

              const ads_found = ads_report_response.data.report_by_time.find(i => +i.key >= start && +i.key <= end)
              first_week.gmv_ads += ads_found ? seller.m__calculate(ads_found.metrics.broad_gmv / 100000) : 0
              first_week.cost_ads += ads_found ? seller.m__calculate(ads_found.metrics.cost / 100000) : 0
              first_week.order_ads += ads_found ? +ads_found.metrics.broad_order : 0
            }
            first_week.cir = +first_week.gmv_ads ? parseFloat((first_week.cost_ads / first_week.gmv_ads * 100).toFixed(2)) : 0
            first_week.roas = +first_week.cost_ads ? parseFloat((first_week.gmv_ads / first_week.cost_ads).toFixed(2)) : 0
            console.log('first_week', first_week)

            const second_week = this.clone(this.temp_data)
            for (let i = 8; i <= 15; i++) {
              const start = this.dayjs(this.date).date(i).startOf('day').unix()
              const end = this.dayjs(this.date).date(i).endOf('day').unix()

              const gmv_found = key_metrics_response.result.place_gmv.points.find(i => i.timestamp >= start && i.timestamp <= end)
              second_week.gmv += gmv_found ? +gmv_found.value : 0

              const ads_found = ads_report_response.data.report_by_time.find(i => +i.key >= start && +i.key <= end)
              second_week.gmv_ads += ads_found ? seller.m__calculate(ads_found.metrics.broad_gmv / 100000) : 0
              second_week.cost_ads += ads_found ? seller.m__calculate(ads_found.metrics.cost / 100000) : 0
              second_week.order_ads += ads_found ? +ads_found.metrics.broad_order : 0
            }
            second_week.cir = +second_week.gmv_ads ? parseFloat((second_week.cost_ads / second_week.gmv_ads * 100).toFixed(2)) : 0
            second_week.roas = +second_week.cost_ads ? parseFloat((second_week.gmv_ads / second_week.cost_ads).toFixed(2)) : 0
            console.log('second_week', second_week)

            const third_week = this.clone(this.temp_data)
            for (let i = 16; i <= 22; i++) {
              const start = this.dayjs(this.date).date(i).startOf('day').unix()
              const end = this.dayjs(this.date).date(i).endOf('day').unix()

              const gmv_found = key_metrics_response.result.place_gmv.points.find(i => i.timestamp >= start && i.timestamp <= end)
              third_week.gmv += gmv_found ? +gmv_found.value : 0

              const ads_found = ads_report_response.data.report_by_time.find(i => +i.key >= start && +i.key <= end)
              third_week.gmv_ads += ads_found ? seller.m__calculate(ads_found.metrics.broad_gmv / 100000) : 0
              third_week.cost_ads += ads_found ? seller.m__calculate(ads_found.metrics.cost / 100000) : 0
              third_week.order_ads += ads_found ? +ads_found.metrics.broad_order : 0
            }
            third_week.cir = +third_week.gmv_ads ? parseFloat((third_week.cost_ads / third_week.gmv_ads * 100).toFixed(2)) : 0
            third_week.roas = +third_week.cost_ads ? parseFloat((third_week.gmv_ads / third_week.cost_ads).toFixed(2)) : 0
            console.log('third_week', third_week)

            const forth_week = this.clone(this.temp_data)
            for (let i = 23; i <= 31; i++) {
              const start = this.dayjs(this.date).date(i).startOf('day').unix()
              const end = this.dayjs(this.date).date(i).endOf('day').unix()

              const gmv_found = key_metrics_response.result.place_gmv.points.find(i => i.timestamp >= start && i.timestamp <= end)
              forth_week.gmv += gmv_found ? +gmv_found.value : 0

              const ads_found = ads_report_response.data.report_by_time.find(i => +i.key >= start && +i.key <= end)
              forth_week.gmv_ads += ads_found ? seller.m__calculate(ads_found.metrics.broad_gmv / 100000) : 0
              forth_week.cost_ads += ads_found ? seller.m__calculate(ads_found.metrics.cost / 100000) : 0
              forth_week.order_ads += ads_found ? +ads_found.metrics.broad_order : 0
            }
            forth_week.cir = +third_week.gmv_ads ? parseFloat((forth_week.cost_ads / forth_week.gmv_ads * 100).toFixed(2)) : 0
            forth_week.roas = +forth_week.cost_ads ? parseFloat((forth_week.gmv_ads / forth_week.cost_ads).toFixed(2)) : 0
            console.log('forth_week', forth_week)

            const first_half = this.clone(this.temp_data)
            for (let i = 1; i <= 15; i++) {
              const start = this.dayjs(this.date).date(i).startOf('day').unix()
              const end = this.dayjs(this.date).date(i).endOf('day').unix()

              const gmv_found = key_metrics_response.result.place_gmv.points.find(i => i.timestamp >= start && i.timestamp <= end)
              first_half.gmv += gmv_found ? +gmv_found.value : 0

              const ads_found = ads_report_response.data.report_by_time.find(i => +i.key >= start && +i.key <= end)
              first_half.gmv_ads += ads_found ? seller.m__calculate(ads_found.metrics.broad_gmv / 100000) : 0
              first_half.cost_ads += ads_found ? seller.m__calculate(ads_found.metrics.cost / 100000) : 0
              first_half.order_ads += ads_found ? +ads_found.metrics.broad_order : 0
            }
            first_half.cir = +first_half.gmv_ads ? parseFloat((first_half.cost_ads / first_half.gmv_ads * 100).toFixed(2)) : 0
            first_half.roas = +first_half.cost_ads ? parseFloat((first_half.gmv_ads / first_half.cost_ads).toFixed(2)) : 0
            console.log('first_half', first_half)

            const last_half = this.clone(this.temp_data)
            for (let i = 16; i <= 31; i++) {
              const start = this.dayjs(this.date).date(i).startOf('day').unix()
              const end = this.dayjs(this.date).date(i).endOf('day').unix()

              const gmv_found = key_metrics_response.result.place_gmv.points.find(i => i.timestamp >= start && i.timestamp <= end)
              last_half.gmv += gmv_found ? +gmv_found.value : 0

              const ads_found = ads_report_response.data.report_by_time.find(i => +i.key >= start && +i.key <= end)
              last_half.gmv_ads += ads_found ? seller.m__calculate(ads_found.metrics.broad_gmv / 100000) : 0
              last_half.cost_ads += ads_found ? seller.m__calculate(ads_found.metrics.cost / 100000) : 0
              last_half.order_ads += ads_found ? +ads_found.metrics.broad_order : 0
            }
            last_half.cir = +last_half.gmv_ads ? parseFloat((last_half.cost_ads / last_half.gmv_ads * 100).toFixed(2)) : 0
            last_half.roas = +last_half.cost_ads ? parseFloat((last_half.gmv_ads / last_half.cost_ads).toFixed(2)) : 0
            console.log('last_half', last_half)

            const sale_data = this.clone(this.temp_data)
            const sale_day = this.spike_days.find(i => i.month === this.dayjs(this.date).month() + 1 && i.type === 'spike_day')
            if (sale_day) {
              if (sale_day) {
                const start = this.dayjs(this.date).date(sale_day.day).startOf('day').unix()
                const end = this.dayjs(this.date).date(sale_day.day).endOf('day').unix()

                const gmv_found = key_metrics_response.result.place_gmv.points.find(i => i.timestamp >= start && i.timestamp <= end)
                sale_data.gmv += gmv_found ? +gmv_found.value : 0

                const ads_found = ads_report_response.data.report_by_time.find(i => +i.key >= start && +i.key <= end)
                sale_data.gmv_ads += ads_found ? seller.m__calculate(ads_found.metrics.broad_gmv / 100000) : 0
                sale_data.cost_ads += ads_found ? seller.m__calculate(ads_found.metrics.cost / 100000) : 0
                sale_data.order_ads += ads_found ? +ads_found.metrics.broad_order : 0
              }
              sale_data.cir = +sale_data.gmv_ads ? parseFloat((sale_data.cost_ads / sale_data.gmv_ads * 100).toFixed(2)) : 0
              sale_data.roas = +sale_data.cost_ads ? parseFloat((sale_data.gmv_ads / sale_data.cost_ads).toFixed(2)) : 0
              console.log('sale_data', sale_data)
            }

            const mini_sale_days = this.spike_days.filter(i => i.month === this.dayjs(this.date).month() + 1 && i.type === 'mini_spike_day')

            const first_mini_data = this.clone(this.temp_data)
            if (mini_sale_days[0]) {
              if (mini_sale_days[0]) {
                const start = this.dayjs(this.date).date(mini_sale_days[0].day).startOf('day').unix()
                const end = this.dayjs(this.date).date(mini_sale_days[0].day).endOf('day').unix()

                const gmv_found = key_metrics_response.result.place_gmv.points.find(i => i.timestamp >= start && i.timestamp <= end)
                first_mini_data.gmv += gmv_found ? +gmv_found.value : 0

                const ads_found = ads_report_response.data.report_by_time.find(i => +i.key >= start && +i.key <= end)
                first_mini_data.gmv_ads += ads_found ? seller.m__calculate(ads_found.metrics.broad_gmv / 100000) : 0
                first_mini_data.cost_ads += ads_found ? seller.m__calculate(ads_found.metrics.cost / 100000) : 0
                first_mini_data.order_ads += ads_found ? +ads_found.metrics.broad_order : 0
              }
              first_mini_data.cir = +first_mini_data.gmv_ads ? parseFloat((first_mini_data.cost_ads / first_mini_data.gmv_ads * 100).toFixed(2)) : 0
              first_mini_data.roas = +first_mini_data.cost_ads ? parseFloat((first_mini_data.gmv_ads / first_mini_data.cost_ads).toFixed(2)) : 0
              console.log('first_mini_data', first_mini_data)
            }

            const second_mini_data = this.clone(this.temp_data)
            if (mini_sale_days[1]) {
              if (mini_sale_days[1]) {
                const start = this.dayjs(this.date).date(mini_sale_days[1].day).startOf('day').unix()
                const end = this.dayjs(this.date).date(mini_sale_days[1].day).endOf('day').unix()

                const gmv_found = key_metrics_response.result.place_gmv.points.find(i => i.timestamp >= start && i.timestamp <= end)
                second_mini_data.gmv += gmv_found ? +gmv_found.value : 0

                const ads_found = ads_report_response.data.report_by_time.find(i => +i.key >= start && +i.key <= end)
                second_mini_data.gmv_ads += ads_found ? seller.m__calculate(ads_found.metrics.broad_gmv / 100000) : 0
                second_mini_data.cost_ads += ads_found ? seller.m__calculate(ads_found.metrics.cost / 100000) : 0
                second_mini_data.order_ads += ads_found ? +ads_found.metrics.broad_order : 0
              }
              second_mini_data.cir = +second_mini_data.gmv_ads ? parseFloat((second_mini_data.cost_ads / second_mini_data.gmv_ads * 100).toFixed(2)) : 0
              second_mini_data.roas = +second_mini_data.cost_ads ? parseFloat((second_mini_data.gmv_ads / second_mini_data.cost_ads).toFixed(2)) : 0
              console.log('second_mini_data', second_mini_data)
            }

            this.result[shop.shop_id] = []
            for (const key of Object.keys(this.temp_data)) {
              const row = {
                key: key,
                label: this.$t(`metric.${key}`),
                total: total[key],
                first_week: first_week[key],
                second_week: second_week[key],
                third_week: third_week[key],
                forth_week: forth_week[key],
                first_half: first_half[key],
                last_half: last_half[key],
                sale_data: sale_data[key],
                first_mini_data: first_mini_data[key],
                second_mini_data: second_mini_data[key]
              }
              this.result[shop.shop_id].push(row)
            }
          }
        }
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      }

      this.loading.get_data = false
    },

    async m__get_spike_days() {
      const resp = await this.$http.get(this.API.URL_API_SRV_2 + '/shopee/spike_days', this.cf())
      this.spike_days = resp.body.data
    },

    m__get_shop_name(id) {
      const shop = this.shopee_shop.list.find(i => i.shop_id === id)
      return shop ? shop.username : ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/center/flash_sale_report.vue